//-- isEmpty 체크--//
function isEmpty(val) {
	if (val == null || typeof val == 'undefind' || val.trim().length < 1) {
		return true;
	}
	return false;
}
export function Formcheck(formName){
	var valid = true;
	var form = $('#' + formName);
	var formData = null;
	form.find('input, textarea, select').each(function(key){
		var obj = $(this);
		if(obj.attr('validation') == 'yes'){
			if(isEmpty(obj.val())){
				alert(obj.attr('title') + '를 입력해주세요');
				$('#'+this.id).focus();

				valid = false;
				return false;
			}
		}
		var selectAttr = obj.attr('type');
		if(selectAttr == 'radio' || selectAttr == 'checkbox' ) {
			var selectCheck = obj.prop('checked');
			if(selectCheck == true) {
				formData = decodeURIComponent(form.serialize());
			}
		}else if(formName == 'loginForm') {
			formData = form.serializeArray();
		}else{
			formData = decodeURIComponent(form.serialize());
		}
	});
	if(valid == true && formData != null){
		formAjaxCall(formName, formData);
	}
}
function formAjaxCall(formName, objVal) {
	if(formName == 'loginForm') {
		loginFunc.memberLogIn(objVal);
	}else if(formName == 'biddingForm') {
		biddingFunc.biddingListData('dateMatch',objVal);
	}else if(formName == 'biddingForm, #biddingSearchForm') {
		biddingFunc.biddingSearchData(objVal);
	}else if(formName == 'favoriteSearchForm') {
		favoriteFunc.favoriteSearchData(objVal);
	}else if(formName == 'operateKeywordSearch') {
		favoriteFunc.favoriteKeywordSearchData(objVal);
	}
}
function trim(obj) {
	return obj.replace(/(^\s*)|(\s*$)/gi, "");
}
//특수문자 제거
export function valueFilter(event) {
	var filter = "[A-Za-z0-9]+";
	if(filter){
		var sKey = String.fromCharCode(event.keyCode);
		var re = new RegExp(filter);
		if(!re.test(sKey))
		{
			event.returnValue=false;
			event.preventDefault();
		}
	}
}

export function checkRadioShowAreaControl(obj){
	var $this = $(obj);
	var name = $this.attr('name');
	$('.targets-'+name).hide();
	$('#' + $this.data('target')).show();
}

export function numberWithCommas(n) {
	return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function uncomma(str) {
	str = String(str);
	return str.replace(/[^\d]+/g, '');
}
export function upperCase(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}



window.uncomma = uncomma;
window.numberWithCommas = numberWithCommas;
window.checkRadioShowAreaControl = checkRadioShowAreaControl;
window.Formcheck = Formcheck;
window.valueFilter = valueFilter;
window.upperCase = upperCase;



// WEBPACK FOOTER //
// ./js/controller/assets/lib/formCheck.js